import React from 'react';
import { Table } from 'antd';
import { TableCol } from './getTableCol';
import { planStruct } from './struct';

export const Plan = ({ state }) => {

  const columns = [
    ...TableCol()
  ];


  return (
    <>
      {
        state?.planning?.length > 0 ?
          <Table {...planStruct.table} columns={columns} dataSource={state.planning} />
          : <></>
      }
    </>
  );
};
